export default __webpack_public_path__ + "static/graphical-table-140ce57042336a8537c6d7526f4df2cd.webp";